import { render } from "./IncDecButtons.vue?vue&type=template&id=6dc7d982&scoped=true"
import script from "./IncDecButtons.vue?vue&type=script&lang=js"
export * from "./IncDecButtons.vue?vue&type=script&lang=js"

import "./IncDecButtons.vue?vue&type=style&index=0&id=6dc7d982&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc7d982"]])

export default __exports__